<template>
    <div v-if="conversation && conversation.contact" class="row" style="height: 100%; border-left: 1px solid rgba(0, 0, 0, 0.05);">
        <div class="col">
            <div class="row" style="padding: .5rem 1rem 0; height: 49px;">

                <div class="col">
                    <ul class="conversation-view-nav">
                        <li><span :class="['status-label', conversation.status]">{{ conversation.status }}</span></li>
                        <li v-if="conversationHasAssignees"><div style="margin: 0 .8rem; width: 1px; background: #ccc;">&nbsp;</div></li>
                        <li v-if="conversationHasAssignees">
                            <avatar-group :users="conversation.assignees" style="display: inline-block; vertical-align: middle;" />
                        </li>
                        <!--<li v-if="conversationHasTags"><div style="margin: 0 .8rem; width: 1px; background: #ccc;">&nbsp;</div></li>
                        <li v-if="conversationHasTags">
                            <div class="tag" v-for="tag in conversation.tags">
                                {{ tag.name }}
                                <span @click="untag(tag)">x</span>
                            </div>
                        </li>!-->
                    </ul>
                </div>

                <div class="text-right">
                    <div v-if="conversationHasTags">
                        <div class="tag" v-for="tag in conversation.tags">
                            {{ tag.name }}
                            <span @click="untag(tag)">x</span>
                        </div>
                    </div>
                    <!--<ul class="conversation-view-nav">
                        <li>
                            <ui-icon-button
                                @click="reply"
                                icon="reply"
                                type="secondary"
                                style="vertical-align: middle;"
                                tooltip="Reply"
                            />
                        </li>
                        <li>
                            <ui-icon-button
                                @click="addNote"
                                icon="comment"
                                type="secondary"
                                style="vertical-align: middle;"
                                tooltip="Add Note"
                            />
                        </li>
                        <li>
                            <assign-button
                                :conversations="[conversation]"
                                :available-users="messageBox.users"
                                @changed="conversationChanged"
                            />
                        </li>
                        <li>
                            <status-button
                                :conversations="[conversation]"
                                @changed="conversationChanged"
                            />
                        </li>
                        <li>
                            <tag-button
                                :conversations="[conversation]"
                                @changed="conversationChanged"
                            />
                        </li>
                        <li>
                            <message-box-button
                                :conversations="[conversation]"
                                @changed="messageBoxChanged"
                            />
                        </li>
                    </ul>!-->
                </div>


                <div class="col-12" style="border-bottom: 1px solid #eee; margin-top: .5rem;"></div>
            </div>
            <conversation-message-pane ref="conversation" negative-y-margin="160px" />
            <conversation-menu :selected="[conversation]" @reply="reply" @note="addNote"></conversation-menu>
        </div>
        <div class="col" style="max-width: 340px; border-left: 1px solid rgba(0, 0, 0, 0.05); overflow-y: auto; max-height: calc(100vh - 110px);">
            <conversation-contact-pane :conversation="conversation"></conversation-contact-pane>
        </div>
    </div>

    <loading-pane v-else />
</template>

<script>
    import Message from "./ConversationMessage";
    import ConversationMessagePane from "./ConversationMessagePane";
    import MessageList from "./MessageListView"
    import AvatarGroup from "../elements/AvatarGroup";
    import AssignButton from "./AssignButton";
    import StatusButton from "./StatusButton";
    import MessageBoxButton from "./MessageBoxButton";
    import LoadingPane from "./LoadingPane";
    import ConversationContactPane from "./ConversationContactPane";
    import TagButton from "./TagButton";
    import ConversationMenu from "./ConversationMenu";

    export default {
        components: {
            ConversationMenu,
            TagButton,
            LoadingPane,
            MessageBoxButton,
            ConversationContactPane,
            StatusButton, AssignButton, ConversationMessagePane, Message, MessageList, AvatarGroup},
        mounted() {
            let payload = {
                conversation_id: this.$route.params.conversation_id
            };

            this.$store.dispatch('inbox/conversations/load', payload).then(() => {
                if (this.$route.params.message_id) {
                    setTimeout(() => {
                        this.$refs.conversation.focus(this.$route.params.message_id)
                    }, 150)
                }

                this.hasCompletedInitialLoad = true
            }).catch(e => {
                console.log(e)
                if (e.response.status === 404) {
                    this.$router.push('/inbox/waiting')
                }
            })

            this.$root.$on('notification', (notification) => {
                if ((notification.data.type === 'inbox.reply.received' || notification.data.type === 'inbox.conversation.assigned') && notification.data.conversation_id === parseInt(this.$route.params.conversation_id)) {
                    this.$store.dispatch('inbox/conversations/reload').then(() => {
                        if (notification.data.message_id) {
                            setTimeout(() => {
                                this.$refs.conversation.focus(notification.data.message_id)
                            }, 150)
                        }
                    })
                }
            })
        },
        watch: {
             '$route.params.conversation_id': {
                handler: function(conversation_id) {
                    if (this.hasCompletedInitialLoad) {
                        this.$store.dispatch('inbox/conversations/load', { conversation_id })
                    }
                },
                deep: true,
                immediate: true
              }
        },
        data() {
            return {
                hasCompletedInitialLoad: false
            }
        },
        computed: {
            conversation() {
                return this.$store.getters['inbox/conversations/conversation']
            },
            conversationHasAssignees() {
                return this.conversation && this.conversation.assignees.length > 0
            },
            conversationHasTags() {
                //return this.conversation && this.conversation.tags.length > 0
                return false
            },
            messageBox() {
                return this.$store.getters['inbox/messageBoxes/find'](
                    this.conversation.message_box_id
                )
            }
        },
        methods: {
            untag(tag) {
                this.$store.dispatch('inbox/conversations/untag', {
                    conversation_id: this.conversation.id, tag: { id: tag.id }
                })
            },
            addNote() {
              this.$refs.conversation.addNote()
            },
            reply() {
                this.$refs.conversation.reply()
            },
            messageBoxChanged(messageBox) {
                this.$router.push('/inbox/' + messageBox.id + '/conversations/' + this.conversation.id)
                this.conversationChanged()
            },
            conversationChanged() {
                this.$store.dispatch('user/badges/update')
            }
        }
    }
</script>

<style lang="scss">
    .conversation-view-nav {
        list-style: none;
        margin-bottom: 0;
        padding-left: 0;
        li { display: inline-block; }
    }

    .tag {
        font-size: .9rem;
        padding: 0 .5rem;
        background: #ccc;
        color: white;
        display: inline-block;
        margin-right: .5rem;
        cursor: pointer;
        line-height: 1.4rem;

        &:hover {
            background: darken(#ccc, 10%);
        }

        span {
            display: inline-block;
            margin-left: .25rem;
        }
    }

    .status-label {
        text-transform: uppercase;
        font-size: .7rem;
        padding: .15rem .25rem;
        margin-left: .5rem;
        font-weight: bold;
        color: #ccc;
        border: 2px solid #ccc;

        &:first-of-type { margin-left: 0; }

        &.waiting {
            border-color: #4caf50;
            color: #4caf50;
        }

        &.bin, &.closed, &.follow-up {
            border-color: gold;
            color: gold;
        }

        &.junk {
            border-color: #bc0101;
            color: #bc0101;
        }
    }
</style>